import { Injectable } from '@angular/core';
import { fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { Construction } from 'src/app/models/domain';
import { MouldDesignAttributesContractV2 } from 'src/generated-clients/mould_design';

@Injectable({
  providedIn: 'root',
})
export class MouldDesignAdapter implements IAdapter<Construction, MouldDesignAttributesContractV2> {
  public adaptToDomain(item: MouldDesignAttributesContractV2): Construction {
    const shotContract = item.shotContract?.shift();

    return new Construction(
      fallbackString(item.id),
      fallbackString(shotContract?.ejectorType?.id),
      fallbackString(shotContract?.ejectorType?.description),
      fallbackString(item.authorizationGroup),
      fallbackString(item.description),
      fallbackString(item.designId),
      fallbackString(item.mouldType?.id),
      fallbackString(item.machineType?.id),
      fallbackString(item.boxConcept?.id),
      fallbackString(item.boxLayout?.id),
      Number(item.numberOfElements),
      Number(shotContract?.gateOpening),
      fallbackString(shotContract?.ejectorTap?.type),
      Number(item.numberOfInserts),
      Boolean(item.inductiveSensor),
      fallbackString(item.mouldType?.description),
      fallbackString(item.machineType?.description),
      fallbackString(item.boxConcept?.description),
      fallbackString(item.boxLayout?.description)
    );
  }
}
